import React from 'react';
import classNames from 'classnames';

export default function InputError({ children, className = '' }) {
  const errorClassNames = classNames(
    'text-red-600 text-sm',
    className
  );
  return (
    <div className={errorClassNames}>
      {children}
    </div>
  );
}
